import React, {Fragment} from 'react';
import dynamic from 'next/dynamic';
import withMainLayout from 'layouts/main';

//-------------------------------------------------------------------
import RoiCalculatorHero from '@/content/roi-calculator/hero';

// Dynamic import of components

const RoiStatsAndCalculator = dynamic(
  () => import('@/content/roi-calculator/roi-calculator-form-section'),
  {
    loading: () => null
  }
);

const FeaturesRoi = dynamic(() => import('@/content/roi-calculator/features-roi'), {
  loading: () => null
});

const PreFooter = dynamic(() => import('../components/prefooter'), {
  loading: () => null
});

const seoMetas = {
  title: 'ATS ROI Calculator | Workable',
  description:
    'Workable ATS ROI calculator helps you understand the potential impact of Workable on your hiring process, productivity, and bottom line.',
  canonical: 'https://www.workable.com/ats-roi-calculator'
};

const RoiPage = props => (
  <>
    <RoiCalculatorHero />
    <RoiStatsAndCalculator />
    <FeaturesRoi />
    <PreFooter />
  </>
);

export default withMainLayout(RoiPage, {...seoMetas});

export {getSharedPageStaticProps as getStaticProps} from 'helpers/sharedPageStaticProps';
